import React from 'react'

import Button from 'components/Button'
import Modal from 'components/Modal'

import { ModalInjectedProps } from 'containers/ModalManager'
import { useToast } from 'containers/ToastManager'

import { useMoveShareToProject } from 'modules/projects/operations'
import { ProjectFragment, ShareListItemFragment } from 'gqlTypes'

import {
  Bold,
  CenterIconText,
  FolderIcon,
} from './ConfirmDraftsMoveModal.styles'

interface ConfirmDraftsMoveModalProps extends ModalInjectedProps {
  newProject: ProjectFragment
  share: ShareListItemFragment
}

function ConfirmDraftsMoveModal(props: ConfirmDraftsMoveModalProps) {
  const { hideModal, newProject, share } = props
  const { showToast } = useToast()

  const [moveShare, { loading }] = useMoveShareToProject({
    onCompleted: project => {
      showToast(`Document moved to "${project.name}"`)
      hideModal()
    },
    onError: errorMessage => {
      showToast(errorMessage, 'negative')
    },
  })

  return (
    <Modal
      title="Move Document?"
      onCancel={hideModal}
      data-testid="confirm-move-modal">
      <Modal.Body>
        <CenterIconText>
          to <FolderIcon />{' '}
          <Bold>
            <span data-testid="project-name">{newProject.name}</span>
          </Bold>
        </CenterIconText>
        <br />
        <br />
        If you move “<Bold data-testid="document-name">{share.name}</Bold>”
        here, everybody in the Workspace will be able to access it.
        <br />
        <br />
        Documents cannot be moved back to My Drafts.
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={hideModal}>Cancel</Button>
        <Button
          loading={loading}
          onClick={() =>
            moveShare({
              shareId: share.identifier,
              projectId: newProject.identifier,
            })
          }
          variant="primary">
          Move Document
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmDraftsMoveModal
